<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Peserta</strong>
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="addUser()">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-button icon="api" @click="assignOJT()" style="margin-bottom: 12px">
                {{ ojtText }}
            </a-button>

            <a-row type="flex" :gutter="16" style="margin-bottom: 12px" v-if="ojt != null">
                <a-col>
                    Cabang<br /> 
                    <a-select
                        placeholder="Pilih Cabang"
                        style="width: 300px"
                        @change="handleBranchChange"
                    >
                        <a-select-option
                            v-for="d in branches"
                            :key="d.hash"
                            :value="d.hash"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    Divisi <br /> 
                    <a-select
                        placeholder="Pilih Divisi"
                        style="width: 300px"
                        @change="handleDivisionChange"
                    >
                        <a-select-option
                            v-for="d in divisions"
                            :key="d.id"
                            :value="d.id"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    Jabatan <br /> 
                    <a-select
                        placeholder="Pilih Jabatan"
                        style="width: 300px"
                        @change="handlePositionChange"
                    >
                        <a-spin v-if="preloadPos" slot="notFoundContent" size="small" />
                        <a-select-option
                            v-for="d in positions"
                            :key="d.id"
                            :value="d.id"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row type="flex" :gutter="16" style="margin-bottom: 12px"  v-if="ojt != null">
                <a-col>
                    Pembimbing <br /> 
                    <a-select
                        placeholder="Pilih Pembimbing"
                        style="width: 300px"
                        @change="handleAdvisorChange"
                    >
                        <a-select-option
                            v-for="d in advisors"
                            :key="d.hash"
                            :value="d.hash"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    Mentor <br /> 
                    <a-select
                        placeholder="Pilih Mentor"
                        style="width: 300px"
                        @change="handleMentorChange"
                    >
                        <a-select-option
                            v-for="d in mentors"
                            :key="d.hash"
                            :value="d.hash"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    Evaluator Pusat <br /> 
                    <a-select
                        placeholder="Pilih Evaluator"
                        style="width: 300px"
                        @change="handleEvaluatorChange"
                    >
                        <a-select-option
                            v-for="d in evaluators"
                            :key="d.hash"
                            :value="d.hash"
                        >
                            {{ d.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    <br/>
                    <a-button type="primary" icon="check" @click="showConfirm()" :loading="processing">
                        Submit
                    </a-button>
                </a-col>
            </a-row>

            <a-table
                class="pcp-table"
                :dataSource="items.members"
                :row-selection="ojt"
                rowKey="hash"
                :pagination="false"
                :loading="loading"
                bordered>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="branch" title="Cabang" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.members.length >= 1 && record.members[0].branch != null">
                            {{ record.members[0].branch.name }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="division" title="Divisi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.members.length >= 1 && record.members[0].division != null">
                            {{ record.members[0].division.name }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="position" title="Jabatan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.members.length >= 1 && record.members[0].position != null">
                            {{ record.members[0].position.name }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="advisor" title="Pembimbing" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.members.length >= 1 && record.members[0].advisor != null">
                            {{ record.members[0].advisor.name }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="mentor" title="Mentor" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.members.length >= 1 && record.members[0].mentor != null">
                            {{ record.members[0].mentor.name }}
                        </div>
                    </template>
                </a-table-column>

                <!-- <a-table-column key="status" title="Status" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tag :color="record.is_active == true ? 'green' : 'red'">
                            {{ record.is_active == true ? "active" : "not active" }}
                        </a-tag>
                    </template>
                </a-table-column> -->

                <a-card size="small" slot="expandedRowRender" slot-scope="record">
                        <a-descriptions title="Pekerjaan">
                            <a-descriptions-item label="Alamat Kantor">
                            {{ record.office_address }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Telepon Kantor">
                            {{ record.office_phone }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Pengalaman Kerja">
                            {{ record.work_experience }}
                            </a-descriptions-item>
                        </a-descriptions>

                        <a-descriptions title="Pendidikan">
                            <a-descriptions-item label="Pendidikan Terakhir">
                            {{ record.education }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Jurusan">
                            {{ record.majors }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Universitas">
                            {{ record.university }}
                            </a-descriptions-item>
                        </a-descriptions>

                        <a-descriptions title="Kontak">
                            <a-descriptions-item label="No. Handphone">
                            {{ record.mobile_phone }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Email">
                            {{ record.email }}
                            </a-descriptions-item>
                        </a-descriptions>

                        <a-descriptions title="Sosial Media">
                            <a-descriptions-item label="Facebook">
                            {{ record.facebook }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Linkedin">
                            {{ record.linkedin }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Twitter">
                            {{ record.twitter }}
                            </a-descriptions-item>
                        </a-descriptions>

                        <a-descriptions title="Lainnya">
                            <a-descriptions-item label="Alamat Rumah">
                            {{ record.home_address }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Telepon Rumah">
                            {{ record.home_phone }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Status Perkawinan">
                                <div v-if="record.family_status != 'undefined'">
                                    {{ record.family_status }}
                                </div>
                            </a-descriptions-item>
                            <a-descriptions-item label="Hobi">
                            {{ record.hobby }}
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>

            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: {},
            loading: false,
            processing: false,
            preloadPos: false,
            ojt: null,
            ojtText: 'Assign OJT',
            advisors: [],
            mentors: [],
            branches: [],
            divisions: [],
            evaluators: [],
            positions: [],
            selectedRowKeys: [],
            formData: {
                branch_id: null,
                division_id: null,
                position_id: null,
                advisor_id: null,
                mentor_id: null,
            },
        }
    },
    created() {
        this.getItems()
        this.fetchAdvisors()
        this.fetchMentors()
        this.fetchBranches()
        this.fetchDivisions()
        this.fetchEvaluators()
        //this.fetchPositions()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        activeBank() {
            return this.$laravel.bank
        },
        activeTraining() {
            return this.$laravel.training
        },
        rowSelection(){
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRowKeys
                },
            }
        }
    },
    methods: {
        getItems() {
            this.loading = true;

            this.$http
                .get(this.routeUri("api.training-members") + "?is_attendant=1")
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        fetchAdvisors() {
            let params = {
                role: 'advisor',
                env: 'all',
                training: this.activeTraining.hash
            }

            this.$http.get(this.routeUri('api.users') + '?' + this.$qs.stringify(params))
                .then((r) => this.advisors = r.data.users)
                .catch((error) => this.handleXhrError(error))
                .finally(() => this.preload = false)
        },
        fetchMentors() {
            let params = {
                role: 'mentor',
                env: 'all',
                training: this.activeTraining.hash
            }

            this.$http.get(this.routeUri('api.users') + '?' + this.$qs.stringify(params))
                .then((r) => this.mentors = r.data.users)
                .catch((error) => this.handleXhrError(error))
                .finally(() => this.preload = false)
        },
        fetchEvaluators() {
            let params = {
                role: 'evaluator',
                env: 'all',
                training: this.activeTraining.hash
            }

            this.$http.get(this.routeUri('api.users') + '?' + this.$qs.stringify(params))
                .then((r) => this.evaluators = r.data.users)
                .catch((error) => this.handleXhrError(error))
                .finally(() => this.preload = false)
        },
        fetchBranches() {
            let params = {
                bank: this.activeBank.hash
            }

            this.$http
                .get(
                    this.routeUri("api.branches") + '?' + this.$qs.stringify(params))
                .then(res => (this.branches = res.data.branches.data))
                .finally(() => (this.preload = false));
        },
        fetchDivisions() {

            let params = {
                bank: this.activeBank.hash
            }

            this.$http
                .get(
                    this.routeUri("api.bank-division") + '?' + this.$qs.stringify(params))
                .then(res => (this.divisions = res.data.divisions.data))
                .finally(() => (this.preload = false));
        },
        fetchPositions(id) {
            this.preloadPos = true;

            let params = {
                division: id
            }

            this.$http
                .get(
                    this.routeUri("api.bank-position") + '?' + this.$qs.stringify(params))
                .then(res => (this.positions = res.data.positions.data))
                .finally(() => (this.preloadPos = false));
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
        addUser() {
            window.location.href = this.routeUri('admin.setting.user.form')
        },
        assignOJT() {
            if(this.ojt == null){
                this.ojt = this.rowSelection
                this.ojtText = 'Tutup'
            }else{
                this.ojt = null
                this.ojtText = 'Assign OJT'
            }
        },
        saveOJT() {
            this.processing = true;

            this.formData.user_ids = this.selectedRowKeys

            let promise;

            promise = this.$http.post(
                this.routeUri("api.training-members.ojt-attendant.assign"),
                this.formData
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            setTimeout(() => location.reload(), 1500);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleBranchChange(value) {
            this.formData.branch_id = value
        },
        handleDivisionChange(value) {
            this.fetchPositions(value)
            this.formData.division_id = value
        },
        handlePositionChange(value) {
            this.formData.position_id = value
        },
        handleAdvisorChange(value) {
            this.formData.advisor_id = value
        },
        handleMentorChange(value) {
            this.formData.mentor_id = value
        },
        handleEvaluatorChange(value) {
            this.formData.evaluator_id = value
        },
        showConfirm() {
            if(this.selectedRowKeys.length == 0) {
                this.$warning({
                    title: 'Peringatan',
                    content: 'Silahkan pilih peserta terlebih dahulu',
                });

                return
            }

            var vm = this
            let placed = 0

            for(let i = 0; i < this.selectedRowKeys.length; i++){
                var arrPlaced = this.items.members.filter(function(ele){
                    return (ele.hash == vm.selectedRowKeys[i] && ele.members[0].branch != null)
                });

                if(arrPlaced.length >= 1){
                    placed++
                }
            }

            var msg = 'Anda yakin akan melakukan submit?'

            if(placed >= 1){
                msg = "Ada " + placed + " peserta yang sudah ditempatkan. Apakah yakin ingin menyimpan?"
            }

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.saveOJT()
                },
                onCancel() {},
                class: 'test',
            });
        },
    }
}
</script>